export default ($resource) => {
    const url = `${SEED_CORE.ENV.API_URL}user/budget-report`;

    return $resource(url, null, {});
};



// WEBPACK FOOTER //
// ./src/app/resources/EmployeeBudgetReport/index.js